import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function SimpleSnackbar({ apiError }) {
  const [open, setOpen] = React.useState(apiError?.val);

  React.useEffect(() => {
    setOpen(apiError?.val);
  }, [apiError]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        testid="snack"
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={apiError?.message}
        action={action}
      />
    </div>
  );
}
